import { http } from 'wagmi';
import { bsc, bscTestnet } from 'wagmi/chains';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { NETWORK_ENV, chainConfig } from './chains';

const isMainnet = NETWORK_ENV === 'mainnet';
const bscChain = isMainnet ? bsc : bscTestnet;

export const supportedChains = [bscChain];

export const WC_PROJECT_ID = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || '';

export const BSC_RPC_URL =
  process.env.REACT_APP_BSC_RPC_URL ||
  process.env.REACT_APP_BSC_TESTNET_RPC_URL ||
  chainConfig('bsc').defaultRpc;

export const wagmiAdapter = new WagmiAdapter({
  projectId: WC_PROJECT_ID,
  networks: supportedChains,
  transports: {
    [bscChain.id]: http(BSC_RPC_URL),
  },
});

export const wagmiConfig = wagmiAdapter.wagmiConfig;

export const getChainById = (chainId) => supportedChains.find(c => c.id === chainId);
export const isSupportedChain = (chainId) => supportedChains.some(c => c.id === chainId);

export const SUPPORTED_NETWORKS = {
  [bscChain.id]: {
    name: bscChain.name,
    shortName: 'bsc',
    rpcUrl: BSC_RPC_URL,
    blockExplorer: bscChain.blockExplorers.default.url,
    nativeCurrency: bscChain.nativeCurrency,
    type: 'evm',
  },
};
